export default __webpack_public_path__ + "images/assets/ae5bd262013c1cad9c30c94a9804b9bf.svg";